import {ISettingsGetter} from '@wix/tpa-settings'
import settingsParams from '../../components/widget/settingsParams'
import {ALL_CATEGORIES_FILTER} from '../constants/settings'

export const getSelectedCategoryIds = (getSetting: ISettingsGetter): string[] => {
  const categoryIdsString = getSetting(settingsParams.selectedCategoryIds) as string
  return categoryIdsString ? categoryIdsString.split(',') : [ALL_CATEGORIES_FILTER]
}

export const getInitialCategoryId = (getSetting: ISettingsGetter): string => {
  const initialCategoryId = getSetting(settingsParams.initialCategoryId) as string
  const defaultCategoryId = initialCategoryId || ALL_CATEGORIES_FILTER
  const selectedCategoryIds = getSelectedCategoryIds(getSetting)

  if (selectedCategoryIds.includes(defaultCategoryId)) {
    return defaultCategoryId
  }

  return selectedCategoryIds[0] || ALL_CATEGORIES_FILTER
}
